import CollectData from './components/Modal'

export default CollectData